import ScenarioActionType from '@/store/modules/scenario/scenario.type'
import { ScenarioService } from '@/services/bot.service'

const types = ScenarioActionType

const ScenarioStoreMixin = {
    [types.CREATE_SCENARIO] (context, data) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        return ScenarioService.create(data.bot_code, data).then(
            result => {
                let scenario = result.data
                context.steps = scenario.steps || []
                context.state.mapCodeToScenario[scenario.code] = scenario
                context.state.scenarioList.push(scenario)
                context.commit(types.ACTIVE_DATA, { activeScenarioCode: scenario.code })
                return scenario
            }
        ).finally(() => {
            context.commit(types.ADD_SAVING_COUNT, -1)
        })
    },
    [types.UPDATE_SCENARIO] (context, payload) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        return ScenarioService.update(context.rootState.bot.code, payload.code, payload).then(
            result => {
                let newScenario = result.data
                let oldScenario = context.state.mapCodeToScenario[payload.code]
                Object.assign(oldScenario, newScenario)
                context.dispatch(types.SHOULD_UPDATE_GRAPH)
                return oldScenario
            }
        ).finally(() => {
            context.commit(types.ADD_SAVING_COUNT, -1)
        })
    },
    [types.DELETE_SCENARIO] (context, payload) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        return ScenarioService.delete(context.rootState.bot.code, payload.code, payload.code).then(
            () => {
                let oldScenario = context.state.mapCodeToScenario[payload.code]
                context.state.mapCodeToScenario[payload.code] = null
                context.state.scenarioList.splice(
                    context.state.scenarioList.indexOf(oldScenario),
                    1
                )
                context.commit(types.ACTIVE_DATA, { activeScenarioCode: context.state.defaultScenarioCode })
                return oldScenario
            }
        ).finally(() => {
            context.commit(types.ADD_SAVING_COUNT, -1)
        })
    },
    [types.POSITION_SCENARIO] (context, data) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        return ScenarioService.updatePosition(
            data.botCode,
            data.scenarioCodeList
        ).then(
            result => result.data
        ).finally(() => {
            context.commit(types.ADD_SAVING_COUNT, -1)
        })
    }
}

export default ScenarioStoreMixin
